// src/pages/Admin.jsx
import { useState } from 'react';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useAdmin } from '../context/AdminContext';
import AdminJobs from '../components/admin/AdminJobs';
import AdminBlog from '../components/admin/AdminBlog';
import AdminApplications from '../components/admin/AdminApplications';
import AdminSubscribers from '../components/admin/AdminSubscribers';

const TABS = [
  { id: 'jobs', label: 'Job Postings', icon: '💼' },
  { id: 'blog', label: 'Blog Posts', icon: '✍️' },
  { id: 'applications', label: 'Applications', icon: '📋' },
  { id: 'subscribers', label: 'Subscribers', icon: '📬' },
];

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState('jobs');
  const { adminUser } = useAdmin();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar__logo">
          <svg width="24" height="32" viewBox="0 0 29 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 0L0 8V24L14.5 32L29 24V8L14.5 0Z" fill="white" fillOpacity="0.15"/>
            <path d="M14.5 4L4 10V22L14.5 28L25 22V10L14.5 4Z" fill="white" fillOpacity="0.4"/>
            <path d="M14.5 8L8 12V20L14.5 24L21 20V12L14.5 8Z" fill="white"/>
          </svg>
          <div>
            <div style={{ color: '#fff', fontSize: '13px', fontWeight: 600, lineHeight: 1.2 }}>District Sourcing</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px' }}>Admin Panel</div>
          </div>
        </div>

        <nav style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '16px' }}>
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`admin-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span style={{ marginRight: '10px' }}>{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '16px' }}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginBottom: '8px', padding: '0 8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {adminUser?.email}
          </p>
          <button className="admin-nav-item" onClick={handleLogout} style={{ width: '100%', textAlign: 'left', color: '#fca5a5' }}>
            ← Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        {activeTab === 'jobs' && <AdminJobs />}
        {activeTab === 'blog' && <AdminBlog />}
        {activeTab === 'applications' && <AdminApplications />}
        {activeTab === 'subscribers' && <AdminSubscribers />}
      </main>
    </div>
  );
}